module.exports = __webpack_public_path__ + "img/sys-update.5af59bb6.svg";